import { useQuery } from '@tanstack/react-query';
import { useQueryCreator } from '~/hooks/useQueryCreator';
import { fetchFulfillmentContextSummaries } from './fetchFulfillmentContextSummaries';

export const FULFILLMENT_CONTEXT_SUMMARIES_HEAVY_QUERY_KEY = 'fulfillmentContextSummaries';

const fulfillmentContextSummariesQuery = {
  queryKey: FULFILLMENT_CONTEXT_SUMMARIES_HEAVY_QUERY_KEY,
  configurationType: 'cached' as const,
  fn: fetchFulfillmentContextSummaries,
};

// TODO merge and de-dupe with useFulfillmentContexts query
export function useFulfillmentContextSummariesQuery() {
  return useQuery({
    ...useQueryCreator(fulfillmentContextSummariesQuery, { args: [] }),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
